<template>
  <div class="mt-5">
    <table class="tabela">
      <thead :style="color">
        <tr>
          <td class="text-left pl-2">
            OS/Pedido
          </td>
          <td class="text-left"> 
            Data
          </td>
          <td class="text-left">
            Solicitante
          </td>
          <td class="text-left pl-4"> 
            Selo
          </td>
          <td class="text-left">
            Forma de pagamento
          </td>
          <!-- <td class="text-left pl-4"> 
            Tipo
          </td> -->
          <td class="text-left pl-3">
            Valor
          </td>
        </tr>
      </thead>
      <tbody class="dados-da-tabela border-top-0">
        <tr v-for="item in frenteCaixa.pedidos" 
            :key="item.cx_pedido_id">
          <td class="text-left td-dados pl-2">
            {{ item.ordemServico ?
              item.ordemServico.numero : 
              item.lancamentosAvulso ?
                item.lancamentosAvulso.cx_lancamento_id :'' }}
          </td>
          <td class="text-left td-dados">
            {{ item.data_lancamento | date }}
          </td>
          <td class="text-left td-dados">
            {{ item.solicitante }}
          </td>
          <td class="text-left td-dados pl-4">
            <TableSelo v-if="item.ordemServico"
                       :prop-selo="item.ordemServico.itens[0].seloItemOs[0]" />
            <span v-else
                  :id="item.cx_pedido_id">
              ---
            </span>
          </td>
          <td class="text-left td-dados">
            <span :id="`recebimento-avulso-tooltip${item.cx_pedido_id}`">
              {{ item.parcelas.length > 1 ? 'Diversas' : item.parcelas[0].forma_pg }}
              <b-badge v-if="item.parcelas.length > 1"
                       variant="light">
                {{ item.parcelas.length }}
              </b-badge>
              <icon-svg v-show="item.parcelas.length > 1"
                        icon="helpCircle"
                        class="icon--sm icon ml-2"
                        style="fill: #074f7f !important;" />
            </span>
            <b-tooltip v-if="item.parcelas.length > 1"
                       :target="`recebimento-avulso-tooltip${item.cx_pedido_id}`"
                       triggers="hover">
              <div v-for="(parcela, index) in item.parcelas"
                   :key="index">
                <div class="d-flex justify-content-between">
                  <span class="mr-1">{{ parcela.forma_pg }}</span>
                  <span>{{ parcela.valor | moneyToString }}</span>
                </div>                  
              </div>
            </b-tooltip>
          </td>
          <!-- <td class="text-left td-dados pl-4">
            {{ item.parcelas[0].tipo_pg }}
          </td> -->
          <td class="text-left td-dados">
            <input id="custa_valor_total_custa"
                   v-money="money"
                   :value="item.valorTotal"
                   disabled
                   class="pl-4 text-left"
                   :class="{'is-invalid' : errors.has('custa_ipesp')}"
                   name="custa_ipesp"
                   size="10px"
                   trim>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  // vuex
  import { mapState } from 'vuex'

  // Imports
  import { VMoney } from 'v-money'

  // Componentes
  import TableSelo from '../../../FrenteDeCaixaPendentes/TableSelo.vue'

  export default {
    name: "TabelaOsPedido",
    directives: {
      money: VMoney
    },
    components: {
      TableSelo,
    },
    data () {
      return {
        color: {
          backgroundColor: "#57bd9c",
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        }
      }
    },
    computed: mapState(['frenteCaixa']),
  }
</script>

<style scoped>
.tabela {
  width: 100%;
}
thead {
  border-right: 1.5px solid #57bd9c;
  border-left: 1px solid #57bd9c;
  font-size:1.2rem;
  font-weight: bolder;
}
.dados-da-tabela {
  border: 0.5px solid #C6C6C6;
}
tbody tr {
  border-top: 0.5px solid #C6C6C6;
}
tbody tr:hover {
  background-color:#f5f5f5;
}
td {
  width: 14%;
  padding-top: 10px;
  padding-bottom: 10px;
}
.td-dados {
  width: 14%;
  padding-top: 25px;
  padding-bottom: 25px;
}
.icon {
      width: 20px;
    }
</style>